

import { buildLambdaUrl } from '~/utils/imageUtils'

export default {
  name: 'CommonImage',
  props: {
    alt: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    // resize는 '398x497' 와 같이 String 형식으로 들어올 수도 있음
    resize: {
      type: [String, Number],
      default: null
    },
    quality: {
      type: Number,
      default: null
    },
    format: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: null
    },
    isStaticImage: {
      type: Boolean,
      default: false
    },
    useSwiperLazy: {
      type: Boolean,
      default: false
    },
    useOriginal: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isErrorHandled: false,
      noImagePath: '/images/tempLy/noimage.png',
      currentSrc: null
    }
  },
  computed: {
    // 자동 resize 적용: 정적 이미지가 아니고, resize prop이 없고, src에 '/resize'가 없으면 'x500' 적용
    effectiveResize () {
      // 원본 이미지 사용 옵션이 켜져있으면 resize 적용 안 함
      if (this.useOriginal) {
        return null
      }
      // resize prop이 명시적으로 제공된 경우 그대로 사용
      if (this.resize !== null) {
        return this.resize
      }
      // 정적 이미지는 resize 적용 안 함
      if (this.isStaticImage) {
        return null
      }
      // src에 이미 '/resize'가 포함되어 있으면 resize 적용 안 함
      if (this.src && typeof this.src === 'string' && this.src.includes('/resize')) {
        return null
      }
      // 그 외의 경우 기본값 'x500' 적용
      return 'x500'
    },
    avifSrc () {
      return this.processedUrl(buildLambdaUrl(this.src, 'thumb', '850'))
    },
    webpSrc () {
      return this.processedUrl(buildLambdaUrl(this.src, 'thumb', '850'))
    },
    defaultSrc () {
      // fallback 이미지도 buildLambdaUrl 사용 (브라우저가 picture 태그를 지원하지 않는 경우)
      return this.processedUrl(buildLambdaUrl(this.src, 'thumb', '850'))
    },
    staticImageSrc () {
      return this.processedUrl(this.src)
    },
    fallbackSrc () {
      return this.error || this.noImagePath
    },
    isCapturedImage () {
      return this.src?.includes('/xcdr/capture')
    }
  },
  watch: {
    // src가 변경될 때마다 currentSrc도 초기화
    src: {
      immediate: true,
      handler () {
        if (typeof this.src !== 'string') {
          this.isErrorHandled = false
          this.currentSrc = this.isStaticImage ? this.staticImageSrc : this.defaultSrc
          return
        }
        const s = this.src.trim()
        if (s && (s.includes('//dims') || s.includes('//xcdr'))) {
          this.isErrorHandled = true
          this.currentSrc = this.fallbackSrc
          this.$emit('error')
          return
        }
        this.isErrorHandled = false
        this.currentSrc = this.isStaticImage ? this.staticImageSrc : this.defaultSrc
      }
    }
  },
  methods: {
    load () {
      this.$emit('load')
    },
    errorImage (e) {
      if (!this.isErrorHandled) {
        this.isErrorHandled = true
        this.currentSrc = this.fallbackSrc
        this.$emit('error', e)
      }
    },
    processedUrl (url) {
      if (!url) { return this.fallbackSrc }
      if (this.isErrorHandled || url.includes(this.noImagePath)) {
        return this.fallbackSrc
      }
      return url
    }
  }
}

